<template lang="pug">
#content
    .zone.content-part(:style="{width: '1600px', margin: '0 auto', padding: '0', overflow:'visible'}")
        .heatmap
            h1 {{params.pagename}}
            p ({{params.url}})
            timeSpan(filters="yesterday", v-model="timespan")
            div
                | 访问地域：
                select(v-model="filterParams.region")
                    option(
                        v-for="item in regionOptions",
                        :key="item",
                        :value="item"
                    ) {{item}}
                | 访问来源：
                select(v-model="filterParams.source")
                    option(
                        v-for="item in sourceOptions",
                        :key="item.id",
                        :value="item.id"
                    ) {{item.value}}
            
                .summary
                    .line
                        span.key PV: 
                        span.value {{summary.pv}}
                    .line
                        span.key UV: 
                        span.value {{summary.uv}}
                    .line
                        span.key 点击量: 
                        span.value {{summary.click}}

                .color-line 热度：
                    .color-unit(v-for="(colorUnit, index) in colorBlock", :key="colorUnit.color") 
                        .color-block(:style="{background: colorUnit.showColor}", @click="filterByColor(index)")

        hr
        div(:style="{width:'1600px', margin:'10px auto', height: maxH + 'px'}", ref="hmCon", class="hm-container")
                iframe(
                    name="heatiframe",
                    width="100%",
                    height="100%",
                    frameborder="0",
                    :src="iframeSrc"
                )
</template>

<script>
/* global _ */
import qs from 'query-string'
import h337 from 'heatmap.js'
import { PROVINCES_OF_CHINA } from './constants'
import { getDateString } from '../../script/util'

const arrToIdVal = arr =>
  arr.map((item, i) => {
    return {
      id: i,
      value: item
    }
  })

/*
  const provinces = ['全国'].concat(PROVINCES_OF_CHINA.slice(0))
  const initialFilterModel = {
    refertype: 0,
    region: provinces[0],
    keyword: ''
  }
  */
const colorBlocks = [
  { color: '#da4e5e', showColor: '#da4e5e', on: true },
  { color: '#e18b51', showColor: '#e18b51', on: true },
  { color: '#eac646', showColor: '#eac646', on: true },
  { color: '#9eb57b', showColor: '#9eb57b', on: true },
  { color: '#54a3b9', showColor: '#54a3b9', on: true }
]

export default {
  data () {
    const yesterday = getDateString.yestoday()
    return {
      params: {},
      timespan: {
        start: yesterday,
        end: yesterday
      },
      hmInstance: null,
      maxH: 1000,
      clickDetails: [],
      maxClick: 0,
      colorBlock: [],
      colorPartionData: [],
      resetData: null,
      regionOptions: ['全国'].concat(PROVINCES_OF_CHINA.slice(0)),
      sourceOptions: arrToIdVal(['全部', '外部链接', '搜索引擎', '直接访问']),
      filterParams: {
        region: '全国',
        source: 0
      },
      summary: {
        pv: '-',
        uv: '-',
        click: '-'
      }
    }
  },
  computed: {
    iframeSrc () {
      const urlValid = /^((http|https):\/\/)/.test(this.params.url)
      const url = decodeURIComponent(this.params.url)
        .replace(/\s/gi, '')
        .replace(/javascript/gi, '')
      return urlValid ? url : ''
    },
    httpParams () {
      const filterParams = this.filterParams
      const params = {
        id: this.params.heatmapId,
        domainId: this.params.domainId,
        start: this.timespan.start,
        end: this.timespan.end
      }

      if (filterParams.region !== '全国') {
        params.province = filterParams.region
      }
      if (filterParams.source !== 0) {
        params.reftype = filterParams.source
      }
      return params
    }
  },
  watch: {
    httpParams (newVal) {
      const allDefined = Object.keys(newVal).every(
        key => newVal[key] !== void 0
      )
      allDefined && this.getSummary()
      allDefined && this.getDetailInfo()
    }
  },
  methods: {
    getHmInstance () {
      const canvas = this.$refs.hmCon.querySelector('.heatmap-canvas')
      canvas && canvas.parentNode.removeChild(canvas)
      return (this.hmInstance = h337.create({
        container: this.$refs.hmCon,
        backgroundColor: 'rgba(0,0,0,0.3)',
        gradient: {
          1: '#ff3f2f',
          0.8: '#fc8824',
          0.6: '#f8dd39',
          0.4: '#69c044',
          0.2: '#3ea5f8'
        },
        radius: 10,
        blur: 0.5
      }))
    },

    getSummary () {
      if (!this.httpParams.domainId) return
      this.$http
        .get('/api/heatmap/getSummary', {
          params: this.httpParams
        })
        .then(res => {
          return res.data
        })
        .then(data => {
          /* eslint-disable no-mixed-operators */
          return (data.list && data.list[0]) || null
        })
        .catch(e => {
          return null
        })
        .then(data => {
          if (data) {
            this.summary = _.extend({}, this.summary, data)
          } else {
            this.summary = {
              pv: '-',
              uv: '-',
              click: '-'
            }
          }
        })
    },

    getDetailInfo () {
      if (!this.httpParams.domainId) return

      this.resetData && this.resetData([])
      this.$http
        .get('/api/heatmap/getDetail', {
          params: this.httpParams
        })
        .then(res => {
          return res.data
        })
        .then(data => {
          return data || null
        })
        .catch(e => {
          return null
        })
        .then(data => {
          if (data) {
            const mh = (data.ext_info && data.ext_info.maxheight) || 32767
            // see http://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
            this.maxH = Math.min(mh, 32767)
            this.clickDetails = _.map(data.list, item => {
              return {
                x: item.x,
                y: item.y,
                value: Number(item.click)
              }
            })
            this.maxClick = _.result(
              _.maxBy(this.clickDetails, 'value'),
              'value'
            )
          } else {
            this.clickDetails = []
            this.maxClick = 0
          }

          this.$nextTick(() => {
            this.getHmInstance().setData({
              data: this.clickDetails,
              max: this.maxClick
            })
            this.resetData && this.resetData(this.clickDetails)
            this.resetData && this.resetData.resize()

            const partion = (Number(this.maxClick) + 1) / 5
            const colorPartionData = _.groupBy(this.clickDetails, point =>
              _.floor(point.value / partion)
            )
            this.colorPartionData = _.values(colorPartionData).reverse()
            this.colorBlock = this.colorPartionData.map(
              (_, i) => colorBlocks[i]
            )
          })
        })
    },

    filterByColor (index) {
      const colorUnit = this.colorBlock[index]
      colorUnit.on = !colorUnit.on
      colorUnit.showColor = colorUnit.on ? colorUnit.color : '#aaa'

      const intervals = this.colorBlock.reduce((accu, unit, index) => {
        unit.on && accu.push(index)
        return accu
      }, [])
      const data = intervals.map((_, index) => this.colorPartionData[index])
      const hmData = {
        data: _.flatten(data),
        max: this.maxClick
      }
      this.getHmInstance().setData(hmData)
      this.resetData && this.resetData(hmData.data)
    }
  },
  created () {
    this.params = JSON.parse(JSON.stringify(qs.parse(location.search)))
    console.log(this.params)
    // this.params = qs.parse(location.search)
  },
  mounted () {
    const resetData = enableDrawRect(this.$refs.hmCon, [])
    this.resetData = data => {
      const total = this.summary.click === '-' ? 0 : Number(this.summary.click)
      resetData(data, total)
    }
    this.resetData.resize = resetData.resize
  }
}

// 画一个矩形，并将数据显示在矩形中
function enableDrawRect (heatmapWrap, data) {
  let wrapperLeft = heatmapWrap.getBoundingClientRect().left
  let wrapperTop = heatmapWrap.getBoundingClientRect().top + window.pageYOffset
  let wrapperRight = heatmapWrap.getBoundingClientRect().right
  let warpperBottom =
    heatmapWrap.getBoundingClientRect().bottom + window.pageYOffset

  let rect
  let startPosition
  let mouseDown = false
  let bindData = data
  let totalVal = 0
  let adjustXY = _.partial(
    (basex, basey, mousex, mousey) => ({
      x: mousex - basex,
      y: mousey - basey
    }),
    wrapperLeft,
    wrapperTop
  )

  function createRect (left, top) {
    const rect = document.createElement('div')
    rect.style.position = 'absolute'
    rect.style.border = '1px solid rgb(164, 186, 158)'
    rect.style.background = 'rgba(38,38,38, 0.5)'
    rect.style.left = `${left}px`
    rect.style.top = `${top}px`
    rect.style.color = '#fff'
    return rect
  }

  const resize = function (e) {
    wrapperLeft = heatmapWrap.getBoundingClientRect().left
    wrapperTop = heatmapWrap.getBoundingClientRect().top + window.pageYOffset
    wrapperRight = heatmapWrap.getBoundingClientRect().right
    warpperBottom =
      heatmapWrap.getBoundingClientRect().bottom + window.pageYOffset
    adjustXY = _.partial(
      (basex, basey, mousex, mousey) => ({
        x: mousex - basex,
        y: mousey - basey
      }),
      wrapperLeft,
      wrapperTop
    )
  }

  window.addEventListener('resize', resize)

  heatmapWrap.addEventListener('mousedown', e => {
    e.preventDefault()
    if (mouseDown === false) {
      const mousePosition = adjustXY(e.pageX, e.pageY)
      startPosition = {
        x: mousePosition.x,
        y: mousePosition.y
      }
      rect = createRect(startPosition.x, startPosition.y)
      heatmapWrap.style.cursor = 'crosshair'
      heatmapWrap.appendChild(rect)
      mouseDown = true
    }
  })

  function isVaildRect (startpos, endpos) {
    const min = 10
    if (
      !endpos ||
      !startpos ||
      (endpos.x - startpos.x < min && endpos.y - startpos.y < min)
    ) {
      return false
    }
    return true
  }

  heatmapWrap.addEventListener('mousemove', e => {
    if (mouseDown === true) {
      const mousePosition = adjustXY(
        e.pageX > wrapperRight ? wrapperRight : e.pageX,
        e.pageY > warpperBottom ? warpperBottom : e.pageY
      )
      if (mousePosition.x < startPosition.x) {
        rect.style.width = `${startPosition.x - mousePosition.x}px`
        rect.style.left = `${mousePosition.x}px`
      } else {
        rect.style.width = `${mousePosition.x - startPosition.x}px`
      }
      if (mousePosition.y < startPosition.y) {
        rect.style.height = `${startPosition.y - mousePosition.y}px`
        rect.style.top = `${mousePosition.y}px`
      } else {
        rect.style.height = `${mousePosition.y - startPosition.y}px`
      }
    }
  })

  const filterAndSumData = (startpos, endpos, points) => {
    if (!isVaildRect(startpos, endpos)) {
      return null
    }
    /* eslint-disable camelcase */
    const points_filtered = _.filter(points, point => {
      return (
        point.x >= startpos.x &&
        point.x <= endpos.x &&
        (point.y >= startpos.y && point.y <= endpos.y)
      )
    })
    return _.sumBy(points_filtered, point => point.value)
  }

  function createCls () {
    const cls = document.createElement('div')
    cls.className = 'cls'

    cls.addEventListener('mousedown', e => {
      e.stopPropagation()
    })

    cls.addEventListener('mouseup', e => {
      e.stopPropagation()
      e.preventDefault()
      const rect = e.target.parentNode
      heatmapWrap.removeChild(rect)
    })

    return cls
  }

  function createText (rate, click, aside) {
    return `<div class="text ${
      aside === true ? 'aside' : ''
    }"><div>点击占比：${rate}</div><div>点击量：${click}</div></div>`
  }

  function formatDecimal (decimal) {
    /* eslint-disable no-self-compare */
    if (decimal !== decimal || decimal === Infinity || decimal === -Infinity) {
      return '-'
    }
    return `${(decimal * 100).toFixed(2)}%`
  }

  heatmapWrap.addEventListener('mouseup', e => {
    const mousePosition = adjustXY(e.pageX, e.pageY)
    let temp
    if (mousePosition.x < startPosition.x) {
      temp = startPosition.x
      startPosition.x = mousePosition.x
      mousePosition.x = temp
    }
    if (mousePosition.y < startPosition.y) {
      temp = startPosition.y
      startPosition.y = mousePosition.y
      mousePosition.y = temp
    }

    const sum = filterAndSumData(startPosition, mousePosition, bindData)
    let aside

    if (
      mousePosition.y - startPosition.y < 50 ||
      mousePosition.x - startPosition.x < 150
    ) {
      aside = true
    }

    if (sum !== null) {
      const textDiv = createText(formatDecimal(sum / totalVal), sum, aside)
      rect.innerHTML = textDiv
      rect.className = 'rect'
      rect.appendChild(createCls())
    } else {
      heatmapWrap.removeChild(rect)
    }

    rect = null
    startPosition = null
    heatmapWrap.style.cursor = 'default'
    mouseDown = false
  })

  const resetData = (data, total) => {
    bindData = data
    totalVal = total
    const rects = document.getElementsByClassName('rect')
    while (rects[0]) {
      heatmapWrap.removeChild(rects[0])
    }
  }
  resetData.resize = resize
  return resetData
}
</script>

<style scoped>
.heatmap {
  position: relative;
  padding: 0 40px;
}
h1 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #384b66;
  font-weight: bold;
}
.ps {
  color: #a3b1bf;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
select {
  width: 8em;
  margin: 0 15px 0 5px;
}
hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eee;
}

.heatmap .summary {
  position: absolute;
  top: 0;
  right: 40px;
  padding: 10px;
  width: 180px;
  height: 86px;
  background: #f6f7f9;
  border: 1px solid #dadfe6;
  font-size: 14px;
}

.heatmap .summary .key {
  color: #738699;
}

.heatmap .summary .value {
  color: #384b66;
}

.heatmap .color-line {
  float: right;
}

.heatmap .color-line .color-unit {
  display: inline-block;
}

.heatmap .color-line .color-unit .color-block {
  display: inline-block;
  border-radius: 4px;
  width: 24px;
  height: 12px;
  margin: 0 0 0 15px;
  cursor: pointer;
}

.heatmap .color-line .color-unit .color-value {
  display: inline-block;
}
</style>

<style>
.hm-container .rect {
  padding: 5px 10px;
}

.hm-container .rect .cls {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAw0lEQVQ4y6WRMQ6CQBBF33ABEhJbLuGlrKSn1dCLBbaewVPoMWiJkD3BWAhk3YybAL/abOa/zP8jqroHjkDGMvVALap6X2GeIckGM0CWBB8dcAacMeyA0zgzKwQ0IvIEygDigFJEXsAtBihUNReR1oNM5lZVc76FzxJVfRir+ga8dwWksQ0YB6ppk5j5H2CRLMBPBKOTKCDMX/lxLEgIuBiZ0wBSx67QAQ1QGIW50XwAdrEzLi6x3+AfEuAKDCvMb6D+AMNhaDuyE5d4AAAAAElFTkSuQmCC);
  position: absolute;
  right: 0;
  top: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: all 0.1s linear;
}

.hm-container .rect .cls:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}

.hm-container .rect .text {
  width: 150px;
  height: 50px;
  color: #fff;
}

.hm-container .rect .text.aside {
  position: absolute;
  right: -155px;
  top: 0;
  background: rgba(38, 38, 38, 0.5);
  border: 1px solid #a4ba9e;
}
</style>



// WEBPACK FOOTER //
// heatmap.vue?64818558